import VizaroLogoImg from '../../assets/Image/Icon/logo.png';

const VizaroIcon = () => (
  <div className="flex">
    <img src={VizaroLogoImg.src} className="w-8 mx-2" alt="logo" />
    <div className="text-xl font-bold text-foreground"> Vizaro</div>
  </div>
);

export default VizaroIcon;
